<template>
  <div>
    <v-btn color="error" @click="showCancelModal = true" :disabled="disabled">
      <div v-if="!disabled">{{ $vuetify.lang.t('$vuetify.labels.stornoAll') }}</div>
      <div v-else class="d-flex align-center justify-center h-100">
        <v-progress-circular :size="25" color="white" indeterminate :width="3" />
      </div>
    </v-btn>
    <DialogComponent
      :header="`${$vuetify.lang.t('$vuetify.labels.stornoAll')}?`"
      :text="$vuetify.lang.t('$vuetify.messages.confirmOrderCancellation', orderId)"
      :show="showCancelModal"
    >
      <template slot="actions">
        <v-btn color="error" @click="showCancelModal = false">{{ $vuetify.lang.t('$vuetify.basic.no') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="confirmCancellation">{{ $vuetify.lang.t('$vuetify.labels.takeProfit') }}</v-btn>
      </template>
    </DialogComponent>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { OrderModel } from '../../common/models/order.model';
import DialogComponent from '../global/DialogComponent.vue';

export default {
  components: {
    DialogComponent,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    show: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showCancelModal: false,
    };
  },

  computed: {
    ...mapGetters({
      status: 'orders/getStatus',
      getOrder: 'orders/getOrder',
    }),

    orderId() {
      return Number(this.$route.params.id);
    },

    order() {
      return this.getOrder(this.orderId);
    },
  },

  watch: {
    showCancelModal(newValue) {
      if (!newValue) {
        this.$emit('close');
      }
    },

    show: {
      immediate: true,
      handler(val) {
        this.showCancelModal = val;
      },
    },
  },

  methods: {
    ...mapActions({
      cancelOrder: 'orderDetail/cancelOrder',
    }),

    confirmCancellation() {
      this.showCancelModal = false;

      this.cancelOrder(this.orderId)
        .then(this._redirectToList)
        .catch(() => {});
    },

    _redirectToList() {
      this.$router.push({ name: 'orders' });
    },
  },
};
</script>
